/* ==========================================================================
   XO Boutique — Blocco H3. Popup newsletter.

   ⚠️ RISCRITTO IL 18/08 — l'invio non passa piu' da fetch.
   La protezione antispam di Shopify e' attiva su questo store. Il token
   captcha lo inietta uno script di Shopify che intercetta il submit NATIVO:
   un fetch con FormData quel token non ce l'ha e il server risponde
   400 "Missing CAPTCHA token". Verificato sul live il 18/08.
   Lo script di Shopify completava poi il suo giro e ricaricava la pagina:
   da qui l'errore che lampeggiava un istante e spariva con tutta la pagina.

   Ora il flusso e' in due tempi:
     1. prima dell'invio si scrive un flag di sessione e si lascia partire il
        form. Shopify fa captcha, crea il cliente, rimanda alla stessa pagina.
     2. al reload si leggono i marcatori renderizzati da Liquid e, se il flag
        c'e', il popup si riapre gia' in stato «fatto» (o con l'errore).

   Il flag serve a distinguere: `form.posted_successfully?` e' vero per
   QUALSIASI form 'customer' della pagina, quello della home compreso. Senza
   flag, chi si iscrive dalla sezione home si vedrebbe aprire un popup addosso.

   Cosa fa, in ordine:
   1. decide se mostrarsi (memoria locale + ritardo), oppure si apre subito
      se sta tornando da un invio
   2. apre in modo accessibile: focus dentro, focus trappolato, ESC chiude,
      scroll del body bloccato, focus restituito a chi l'aveva
   3. ricorda la chiusura per N giorni; l'iscrizione la ricorda per sempre

   Nessuna dipendenza, nessuna libreria.

   NOTA
   Senza JS il popup non compare affatto (l'attributo `hidden` lo toglie solo
   questo file). Non e' un degrado: e' una scelta. Chi ha JS disattivato vede
   comunque il form newsletter nella sezione home, che funziona in POST puro.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-xo-popup]');
  if (!root) return;

  var box = root.querySelector('.xo-pop__box');
  if (!box) return;

  var KEY = 'xo:newsletter-popup';
  var PENDING = 'xo:newsletter-pending';
  var form = document.getElementById('xo-pop-form');
  var errEl = root.querySelector('[data-xo-popup-error]');
  var bodyEl = root.querySelector('[data-xo-popup-body]');
  var doneEl = root.querySelector('[data-xo-popup-done]');
  var doneTextEl = root.querySelector('[data-xo-popup-done-text]');
  var lastFocus = null;
  var opened = false;

  /* --- Memoria ------------------------------------------------------------
     Due stati distinti: "chiuso" scade dopo N giorni, "iscritto" non scade.
     localStorage puo' lanciare in navigazione privata o con lo storage
     bloccato: ogni accesso e' protetto e in caso di errore il popup si
     comporta come se non avesse memoria. Meglio mostrarlo una volta di troppo
     che rompere la pagina.
     La memoria e' per origine, quindi condivisa tra / e /en/: chi chiude il
     popup in italiano non lo rivede in inglese. Voluto.                     */
  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '{}');
    } catch (e) {
      return {};
    }
  }
  function write(obj) {
    try {
      localStorage.setItem(KEY, JSON.stringify(obj));
    } catch (e) {
      /* memoria non disponibile: si prosegue senza */
    }
  }
  function markSubscribed() {
    var st = read();
    st.subscribed = true;
    write(st);
  }

  /* Il flag di invio sta in sessionStorage, non in localStorage: deve valere
     per il solo giro di redirect, e sparire se l'utente chiude la scheda. */
  function takePending() {
    try {
      var v = sessionStorage.getItem(PENDING);
      sessionStorage.removeItem(PENDING);
      return v === '1';
    } catch (e) {
      return false;
    }
  }
  function setPending() {
    try {
      sessionStorage.setItem(PENDING, '1');
    } catch (e) {
      /* senza sessionStorage la conferma non si riapre: l'iscrizione
         funziona lo stesso, si perde solo il messaggio di ritorno */
    }
  }

  function shouldShow() {
    var st = read();
    if (st.subscribed) return false;
    if (!st.closedAt) return true;
    var days = parseInt(root.dataset.days, 10);
    if (isNaN(days) || days < 0) days = 30;
    return Date.now() - st.closedAt > days * 864e5;
  }

  /* --- Convivenza con i drawer Kalles -------------------------------------
     ⚠️ La motivazione scritta qui fino al 19/08 era SBAGLIATA, e la correzione
     e' il motivo di questo blocco. Diceva: «.hdt-dialog sta a z-index 999, il
     popup a 998, quindi il popup si aprirebbe invisibile». Il confronto fra
     z-index non c'entra niente.

     Il drawer Kalles e' un <dialog> aperto con showModal(). Verificato a video
     il 19/08 sul sito pubblico: CartDrawer.matches(':modal') === true. Un
     elemento nel TOP LAYER sta sopra qualunque z-index dello stacking context
     normale: anche z-index 999999 perderebbe. E il suo ::backdrop intercetta
     ogni click. Misurato: con i due aperti insieme,
     document.elementFromPoint() sul campo email del popup restituisce il
     drawer. Il popup risulta aperto ma inservibile.

     uiBusy() da sola non basta: e' un controllo UNA TANTUM, valutato in open()
     prima di mostrare. Se il carrello si apre DOPO — o mentre e' ancora in
     `dialog-opening`, che e' la finestra piu' probabile — la guardia e' gia'
     passata. Serve anche watchUi(), che sorveglia mentre il popup e' aperto.  */
  function uiBusy() {
    return document.documentElement.classList.contains('hdt-modal-opened') ||
           document.body.classList.contains('is--opend-drawer') ||
           !!document.querySelector('dialog[open], .hdt-dialog[open]');
  }

  /* Sorveglianza attiva mentre il popup e' aperto.
     Due observer invece di uno: il segnale `open` va cercato in tutto il
     sottoalbero (il <dialog> puo' stare ovunque), mentre le classi di stato
     Kalles stanno solo su <html> e <body>. Un solo observer con
     attributeFilter ['open','class'] e subtree true si sveglierebbe a ogni
     cambio di classe della pagina — centinaia di volte, per animazioni che non
     ci riguardano.                                                          */
  var uiObservers = [];
  function watchUi() {
    /* ⚠️ Senza MutationObserver si torna in silenzio al comportamento vecchio:
       popup dietro al drawer ed ESC dirottato. E' una degradazione accettata,
       non un caso dimenticato — l'API e' supportata ovunque tranne IE10-. */
    if (uiObservers.length || typeof MutationObserver !== 'function') return;

    /* Coalescing: `react` viene eseguita una volta per task invece che una per
       mutazione. L'observer su `['open']` gira in subtree su tutto il body, e
       il popup e' montato da theme.liquid su OGNI pagina — PDP e carrello
       comprese, dove caroselli e accordion mutano attributi in continuazione.

       ⚠️ `setTimeout` e NON `requestAnimationFrame`, che era la prima
       stesura del 19/08. rAF e' sospeso nelle schede in secondo piano:
       misurato sul sito live con `document.visibilityState === 'hidden'`, la
       callback non e' MAI stata eseguita e il popup e' rimasto aperto dietro
       al drawer. rAF e' l'attrezzo giusto per disegnare, non per decidere:
       questa e' una decisione di correttezza e non deve dipendere dal fatto
       che il browser stia dipingendo. I timer nelle schede nascoste vengono
       rallentati, non sospesi. */
    var inCoda = false;
    var react = function () {
      if (inCoda) return;
      inCoda = true;
      setTimeout(function () {
        inCoda = false;
        if (opened && uiBusy()) retreat();
      }, 0);
    };

    var oStato = new MutationObserver(react);
    oStato.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    oStato.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    var oDialog = new MutationObserver(react);
    oDialog.observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });

    uiObservers = [oStato, oDialog];
  }
  function unwatchUi() {
    for (var i = 0; i < uiObservers.length; i++) uiObservers[i].disconnect();
    uiObservers = [];
  }

  /* Ritirata: il popup si toglie di mezzo perche' e' arrivato qualcosa di piu'
     importante, NON perche' l'utente l'abbia rifiutato.
     La distinzione e' tutta in `remember: false`. Scrivere closedAt qui
     significherebbe bruciare i 30 giorni di memoria per un popup che l'utente
     non ha mai potuto vedere: aprire il carrello equivarrebbe a dire «no
     grazie» per un mese. Il focus non torna a lastFocus perche' l'utente sta
     gia' guardando il drawer, ed e' il drawer che deve tenerselo.            */
  /* ⚠️ `setTimeout(open, …)` NON si scrive mai. Il primo parametro di open()
     e' `immediate`, il flag che SALTA uiBusy(): se il motore invoca la
     callback con un argomento truthy — Firefox ci ha storicamente passato la
     "lateness" in ms — la guardia si disattiva e il popup si apre sopra al
     drawer, cioe' esattamente il bug che questo blocco chiude. Sempre
     `setTimeout(function () { open(); }, …)`. Vale per tutti e tre i punti di
     riprogrammazione del file, incluso quello iniziale in fondo, che aveva lo
     stesso difetto da prima di questa modifica. */
  function riprova(ms) {
    setTimeout(function () { open(); }, ms);
  }

  function retreat() {
    if (!opened) return;
    /* La conferma di iscrizione non si ritira. Percorso: ritorno da invio ->
       markSubscribed() -> open(true) con la conferma a schermo. Se qui ci
       ritirassimo, shouldShow() sarebbe gia' false (st.subscribed = true), il
       timer non verrebbe riprogrammato, cleanUrl() ha gia' tolto
       ?customer_posted e la persona non saprebbe MAI di essersi iscritta.
       Nessun dato perso, ma la promessa fatta dal form resta muta. */
    if (doneEl && !doneEl.hidden) return;
    close({ remember: false, restoreFocus: false });
    if (shouldShow()) riprova(3000);
  }

  function reduced() {
    return matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* --- Focus trap ---------------------------------------------------------
     Lista ricalcolata a ogni Tab: il contenuto cambia dopo l'invio (il form
     sparisce, resta la conferma) e una lista congelata all'apertura
     punterebbe a nodi ormai nascosti.                                       */
  function focusables() {
    return Array.prototype.filter.call(
      box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* `immediate` salta l'attesa sui drawer: quando si torna da un invio la
     conferma va mostrata comunque, non rimandata di tre secondi. */
  var tentativi = 0;
  var MAX_TENTATIVI = 20;   /* 20 x 3s = un minuto di attesa, poi si rinuncia */

  function open(immediate) {
    if (opened) return;
    if (!immediate) {
      /* Ricontrollo a ogni tentativo, non solo alla programmazione del primo
         timer: fra un retry e l'altro l'utente puo' essersi iscritto da un
         altro form della pagina, e riaprire un popup a chi si e' appena
         iscritto e' il modo piu' rapido per farlo disiscrivere. */
      if (!shouldShow()) return;
      if (uiBusy()) {
        /* Tetto ai tentativi: senza, un `dialog[open]` residuo su una pagina
           terrebbe in vita un timer ogni 3 secondi per tutta la durata della
           visita. Dopo un minuto la promozione ha perso il suo momento
           comunque: meglio rinunciare che continuare a bussare. */
        if (++tentativi > MAX_TENTATIVI) return;
        riprova(3000);
        return;
      }
    }
    opened = true;
    tentativi = 0;
    /* ⚠️ Se ci si e' appena ritirati davanti a un drawer, `document
       .activeElement` sta DENTRO quel drawer, che a breve verra' chiuso e
       nascosto: memorizzarlo significa restituire il focus a un nodo morto.
       In quel caso non si memorizza niente e la chiusura lascia il focus dove
       il browser lo ha rimesso. */
    var candidato = document.activeElement;
    lastFocus = (candidato && candidato !== document.body && !uiBusy()) ? candidato : null;
    root.hidden = false;
    /* Doppio rAF: il primo attacca il nodo al layout, il secondo fa partire
       la transizione. Con un solo frame il browser accorpa i due stati e
       l'animazione non parte. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-open'); });
    });
    document.documentElement.classList.add('xo-pop-lock');
    document.addEventListener('keydown', onKeydown);
    /* Da qui in poi il controllo non e' piu' una tantum: se si apre un drawer
       mentre il popup e' a schermo, watchUi() lo fa ritirare. Senza questa
       riga il popup resta aperto dietro al ::backdrop del <dialog>, e il suo
       handler di ESC — agganciato a document — intercetta l'Escape con cui
       l'utente sta cercando di chiudere il CARRELLO: misurato il 19/08,
       defaultPrevented diventa true e il carrello resta aperto. */
    watchUi();

    var target = null;
    if (doneEl && !doneEl.hidden) {
      target = doneTextEl;
    } else if (form) {
      target = form.querySelector('input[type="email"]');
    }
    (target || box.querySelector('[data-xo-popup-close]') || box).focus();
  }

  /* `opts` e' opzionale. `close` e' anche il listener dei click sulla X e sullo
     scrim, quindi puo' arrivare un oggetto Event al posto delle opzioni: un
     Event non ha `remember` ne' `restoreFocus`, e i due default valgono
     «l'utente ha chiuso», che e' il caso giusto per un click.
     Si leggono le due opzioni SINGOLARMENTE invece di sostituire l'oggetto in
     blocco: con la sostituzione un futuro `close({ restoreFocus: false })`
     verrebbe silenziosamente convertito in `restoreFocus: true`, perche'
     `remember` non e' un boolean. Oggi non morderebbe — l'unico call site con
     opzioni le passa entrambe — ma e' una trappola per chi verra' dopo. */
  function close(opts) {
    if (!opened) return;
    var ricorda = !(opts && opts.remember === false);
    var ridaiFocus = !(opts && opts.restoreFocus === false);

    opened = false;
    /* ⚠️ `unwatchUi()` PRIMA di toccare le classi, non dopo. Due righe sotto si
       rimuove una classe da <html>, che e' esattamente cio' che `oStato` sta
       osservando: staccare gli observer per ultimi significa auto-notificarsi
       durante la propria chiusura. Oggi non si innescherebbe un loop perche'
       `disconnect()` svuota la coda dei record, ma e' una correttezza che
       dipende dall'ordine di due righe — cioe' si rompe alla prima
       riorganizzazione, in silenzio. */
    unwatchUi();
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKeydown);

    /* Lo scroll lock si toglie SUBITO.
       La prima stesura del 19/08 lo rimandava di un frame, per evitare che fra
       la nostra rimozione e l'applicazione del `html[scroll-lock]` di Kalles
       ci fosse un frame scrollabile — un salto pari alla larghezza della
       scrollbar mentre il drawer entra. Rinunciato, per due motivi misurati:

       1. rAF non gira nelle schede in secondo piano, quindi il rinvio poteva
          lasciare `xo-pop-lock` su <html> a tempo indeterminato: pagina
          bloccata. Un difetto certo per evitarne uno ipotetico.
       2. Il salto e' largo `--scrollbar-w`, che su questo store misura **0px**
          (scrollbar in overlay). Si vedrebbe solo su desktop con scrollbar
          classiche, per un frame.

       Rimane quindi un rischio residuo di un frame su Windows/Linux, accettato
       consapevolmente: e' piu' piccolo e piu' raro del blocco che il rinvio
       introduceva. */
    document.documentElement.classList.remove('xo-pop-lock');

    if (ricorda) {
      var st = read();
      if (!st.subscribed) {
        st.closedAt = Date.now();
        write(st);
      }
    }

    /* Il nodo esce dal flusso a transizione finita. --xo-mid vale 320ms, ma
       si ascolta transitionend e il timeout resta solo come rete: se la
       transizione non parte (reduced motion, tab in background) si chiude
       comunque. */
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      box.removeEventListener('transitionend', finish);
      if (!opened) root.hidden = true;
    }
    if (reduced()) {
      finish();
    } else {
      box.addEventListener('transitionend', finish);
      setTimeout(finish, 400);
    }

    /* Restituzione del focus, con due reti.
       1. `ridaiFocus` false quando ci si ritira davanti a un drawer: li' il
          focus lo tiene il drawer, che l'ha gia' preso lui.
       2. `isConnected` e `offsetParent` perche' `lastFocus` puo' essere un
          nodo tolto dal DOM o nascosto nel frattempo: `.focus()` su un
          elemento invisibile non fa niente e il focus si perde a fondo pagina,
          senza che nessun errore lo segnali.
       Se il focus e' rimasto DENTRO il popup e non abbiamo un posto dove
       rimetterlo, si toglie a mano: fra 400ms `root.hidden = true` lo
       butterebbe comunque su <body>, ma passando da un frame in cui l'elemento
       focalizzato e' gia' invisibile. */
    var vivo = ridaiFocus && lastFocus && typeof lastFocus.focus === 'function' &&
               lastFocus.isConnected !== false && lastFocus.offsetParent !== null;
    if (vivo) {
      lastFocus.focus();
    } else if (box.contains(document.activeElement) && document.activeElement.blur) {
      document.activeElement.blur();
    }
    lastFocus = null;
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-xo-popup-close]'), function (el) {
    el.addEventListener('click', close);
  });

  function showError(message) {
    if (!errEl) return;
    /* Prima si rende visibile la live region, poi si scrive: un role="alert"
       modificato mentre e' `hidden` non viene annunciato in modo affidabile. */
    errEl.hidden = false;
    errEl.textContent = message;
  }

  function showDone() {
    if (bodyEl) bodyEl.hidden = true;
    if (doneEl) doneEl.hidden = false;
    if (doneTextEl) {
      /* Il testo viene scritto DOPO aver tolto `hidden`: e' il cambio di
         contenuto in una region gia' visibile che fa scattare l'annuncio. */
      doneTextEl.textContent = root.dataset.successText || '';
      doneTextEl.setAttribute('tabindex', '-1');
    }
  }

  /* --- Invio --------------------------------------------------------------
     Nessun preventDefault: il form parte nativo, Shopify aggiunge il token
     captcha e reindirizza. Qui si lascia solo una traccia di chi ha inviato.
     La casella di consenso e' `required`: se non e' spuntata questo handler
     non viene mai eseguito, perche' il browser annulla il submit prima.      */
  if (form) {
    form.addEventListener('submit', function () {
      setPending();
      var btn = form.querySelector('button[type="submit"]');
      /* Disabilitare il bottone PRIMA che il form parta annullerebbe l'invio
         in alcuni browser: si aspetta il turno successivo. */
      if (btn) setTimeout(function () { btn.disabled = true; }, 0);
    });
  }

  /* --- Esito di ritorno ---------------------------------------------------
     I due marcatori li renderizza Liquid dentro il popup:
       [data-xo-popup-server-ok]    -> form.posted_successfully?
       [data-xo-popup-server-error] -> form.errors
     Sono veri per qualunque form 'customer' della pagina: e' `pending` a dire
     se e' stato questo popup a inviare.                                      */
  var srvOk = !!root.querySelector('[data-xo-popup-server-ok]');
  var srvErrEl = root.querySelector('[data-xo-popup-server-error]');
  var srvErr = srvErrEl ? srvErrEl.textContent.trim() : '';
  var pending = takePending();

  /* Ripulisce `?customer_posted=true` dalla barra degli indirizzi: se resta,
     un refresh riapre la conferma a chi non ha inviato niente. */
  function cleanUrl() {
    if (!window.history || !history.replaceState) return;
    if (location.search.indexOf('customer_posted') === -1) return;
    try {
      var url = new URL(location.href);
      url.searchParams.delete('customer_posted');
      history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (e) { /* URL non supportata: si lascia com'e' */ }
  }

  if (srvOk) {
    /* L'iscrizione e' andata a buon fine, da qualunque form sia partita:
       il popup non deve piu' chiedere l'email a questa persona. */
    markSubscribed();
    cleanUrl();
    if (pending) {
      showDone();
      open(true);
      /* La conferma resta finche' non la si chiude. La prima versione la
         faceva sparire dopo 5 secondi: su una lettura lenta il messaggio se
         ne andava prima di essere letto. */
    }
  } else if (srvErr && pending) {
    cleanUrl();
    showError(srvErr || root.dataset.errorGeneric || '');
    open(true);
  } else if (pending) {
    /* Invio partito, ritorno senza marcatori: il caso non dovrebbe capitare,
       ma se capita e' meglio dirlo che fingere che sia andata bene. */
    cleanUrl();
    showError(root.dataset.errorGeneric || '');
    open(true);
  } else if (shouldShow()) {
    var delay = parseInt(root.dataset.delay, 10);
    if (isNaN(delay) || delay < 0) delay = 5;
    /* Difetto preesistente, non introdotto dalla modifica del 19/08: passando
       `open` per reference, la callback riceve un argomento dal motore e
       quell'argomento finisce in `immediate`, disattivando uiBusy() gia' alla
       PRIMA apertura. Vedi il commento su `riprova()`. */
    riprova(delay * 1000);
  }
})();
